export const units = [
  { id: 'W01', floor: 'UG', rooms: '2 Zi.', area: '87 m²', price: '€ 415.000', status: 'available', statusName: '' },
  { id: 'W02', floor: 'UG', rooms: '2 Zi.', area: '79,43 m²', price: '€ 395.000', status: 'available', statusName: '' },
  { id: 'W03', floor: 'UG', rooms: '3 Zi.', area: '78,68 m²', price: '€ 425.000', status: 'available', statusName: '' },
  { id: 'W04', floor: '0. OG', rooms: '3 Zi.', area: '102,4 m²', price: '€ 575.000', status: 'available', statusName: '' },
  { id: 'W05', floor: '0. OG', rooms: '2 Zi.', area: '70,19 m²', price: 'Auf Anfrage', status: 'reserved', statusName: 'Reserviert' },
  { id: 'W06', floor: 'EG', rooms: '3 Zi.', area: '107,97 m²', price: '€ 595.000', status: 'available', statusName: '' },
  { id: 'W07', floor: '1. OG', rooms: '3 Zi.', area: '83,26 m²', price: '€ 585.000', status: 'available', statusName: '' },
  { id: 'W08', floor: '1. OG', rooms: '2 Zi.', area: '65,05 m²', price: '€ 425.000', status: 'available', statusName: '' },
  { id: 'W09', floor: '1. OG', rooms: '3 Zi.', area: '93,71 m²', price: '€ 625.000', status: 'available', statusName: '' },
  { id: 'W10', floor: '2. OG', rooms: '4 Zi.', area: '122,34 m²', price: 'Auf Anfrage', status: 'available', statusName: '' },
  { id: 'W11', floor: '2. OG', rooms: '4 Zi.', area: '123,16 m²', price: 'Auf Anfrage', status: 'available', statusName: '' },
];

export const galleryImages = [
  { thumb: '/img/baufortschritt-aktuell-april-2025.avif', full: '/img/baufortschritt-aktuell-april-2025.avif', caption: 'Baustelle · April 2025' },
  { thumb: '/img/Am Waldrand Oberbozen 1 500.avif', full: '/img/Am Waldrand Oberbozen 1 1800.avif', caption: 'Architektur' },
  { thumb: '/img/Am Waldrand Oberbozen 2 500.avif', full: '/img/Am Waldrand Oberbozen 2 1800.avif', caption: 'Wohnkomfort' },
  { thumb: '/img/Am Waldrand Oberbozen 4 500.avif', full: '/img/Am Waldrand Oberbozen 4 1800.avif', caption: 'Panoramablick' },
  { thumb: '/img/Am Waldrand - Oberbozen Ferienwohnung (1) 500.avif', full: '/img/Am Waldrand - Oberbozen Ferienwohnung (1) 1500.avif', caption: 'Ferienwohnung I' },
  { thumb: '/img/Am Waldrand - Oberbozen Ferienwohnung (2) 500.avif', full: '/img/Am Waldrand - Oberbozen Ferienwohnung (2) 1500.avif', caption: 'Ferienwohnung II' },
  { thumb: '/img/Am Waldrand - Oberbozen Ferienwohnung (3) 500.avif', full: '/img/Am Waldrand - Oberbozen Ferienwohnung (3) 1500.avif', caption: 'Ferienwohnung III' },
];

export const lageItems = [
  {
    icon: 'arrow',
    title: 'In 12 Minuten ins Zentrum',
    text: 'Entfliehen Sie dem Trubel und der Sommerhitze des Bozner Talkessels. Die Rittner Seilbahn bringt Sie in nur 12 Minuten von der Ruhe am Waldrand direkt in die Altstadt von Bozen.'
  },
  {
    icon: 'train',
    title: 'Das Rittner Bahnl & Skigebiet',
    text: 'Die historische Schmalspurbahn verbindet Oberbozen mit Klobenstein. Von dort aus sind die Ski- und Wandergebiete rund um das Rittner Horn in greifbarer Nähe.'
  },
  {
    icon: 'nature',
    title: 'Naturidylle ab der Haustür',
    text: 'Direkt am Waldrand gelegen, beginnen Wander- und Spazierwege buchstäblich vor Ihrer Tür. Eine perfekte Balance aus Abgeschiedenheit und dörflicher Infrastruktur (Gastronomie, Apotheke, Supermarkt). Wohnung kaufen am Ritten – hier lebt man mit der Natur, nicht neben ihr.'
  }
];

export const ausstattungItems = [
  {
    icon: 'layers',
    title: 'KlimaHaus Standard',
    text: 'Modernste Bauweise kombiniert mit einem ausgeklügelten Energiekonzept. Höchste Effizienz, niedrigste Energiekosten und nachhaltiger Wohnkomfort, der dem alpinen Klima Rechnung trägt.'
  },
  {
    icon: 'terrace',
    title: 'Panoramaterrassen & Gärten',
    text: 'Weite, bodentiefe Fensterfronten öffnen den Wohnraum zur Natur. Großzügige Eigengärten im Erdgeschoss und großzügige Terrassen bei den Wohnungen laden zum Genießen des Bergpanoramas ein.'
  },
  {
    icon: 'shield',
    title: 'Privatsphäre & Sicherheit',
    text: 'Durchdachte Grundrisse, akustische Entkopplung und exklusive Materialwahl schaffen Rückzugsorte vollkommener Ruhe. Inklusive geschützter Tiefgaragenstellplätze für alle Einheiten.'
  }
];
